import { makeStyles } from "@material-ui/core/styles";

const useStyles = makeStyles((theme) => ({
  paper: {
    padding: theme.spacing(2),
    marginTop: theme.spacing(5),
    textAlign: "center",
    position: "relative",
    [theme.breakpoints.down("sm")]: {
      marginBottom: theme.spacing(2),
      marginTop: theme.spacing(2),
    },
  },
  root: {
    display: "flex",
    color: theme.palette.primary.contrastText,
    paddingTop: theme.spacing(3),
    minHeight: "100vh",
    background: `url("/mentoro-icon-background.svg") repeat center center fixed;`,
  },
  skipBtn: {
    marginBottom: 24,
  },
  title: {
    marginTop: theme.spacing(12),
    [theme.breakpoints.down("sm")]: {
      fontSize: 24,
      marginTop: theme.spacing(2),
    },
  },
  formWrapper: {
    width: "100%",
    padding: 0,
    backgroundColor: "#FFFFFF",
    position: "relative",
  },
  ribbonImage: {
    position: "absolute",
    width: "20%",
    left: 0,
    right: 0,
    marginLeft: "auto",
    marginRight: "auto",
    height: "150px !important",
    maxWidth: "250px !important",
    maxHeight: "150px !important",
    minHeight: "30px !important",
    [theme.breakpoints.only("xs")]: {
      top: theme.spacing(-9),
    },
    [theme.breakpoints.only("sm")]: {
      top: theme.spacing(-9),
    },
    [theme.breakpoints.only("md")]: {
      top: theme.spacing(-8),
    },
    [theme.breakpoints.up("lg")]: {
      top: theme.spacing(-8),
    },
  },
  video: {
    height: "500px",
    paddingBottom: theme.spacing(3),
    paddingTop: theme.spacing(3),
    [theme.breakpoints.only("xs")]: {
      height: "auto",
    },
    [theme.breakpoints.only("sm")]: {
      height: "auto",
    },
  },
}));

export default useStyles;
